import React, { useState } from 'react'
import Alert from '../Alert'
import { getBannerConfigs } from './bannerConfigs'

/**
 * BannerManager - Manages sequential display of banners
 *
 * Banners are displayed in priority order. Only the first active banner
 * that hasn't been dismissed will be shown. When dismissed, the next
 * banner in the list will automatically appear if its conditions are met.
 *
 * @param {Object} system - Current system object from AuthContext
 * @param {Object} user - Current user object from AuthContext
 */
export default function BannerManager({ system}) {
  const bannerConfigs = getBannerConfigs(system)

  const getActiveBanner = () => {
    for (const config of bannerConfigs) {
      if (!config.show) continue
      const dismissed = localStorage.getItem(config.storageKey)
      if (dismissed !== 'true') {
        return config
      }
    }
    return null
  }

  const [activeBanner, setActiveBanner] = useState(getActiveBanner())

  const handleBannerDismiss = () => {
    if (activeBanner) {
      localStorage.setItem(activeBanner.storageKey, 'true')
      setActiveBanner(getActiveBanner())
    }
  }

  if (!activeBanner) return null

  return (
    <Alert
      type={activeBanner.type}
      message={activeBanner.message}
      visible={!!activeBanner}
      onDismiss={handleBannerDismiss}
    />
  )
}

/**
 * Helper function to clear all banner dismissal states from localStorage
 * Call this on logout to reset banners for next login
 *
 * @param {Object} system - Current system object from AuthContext
 */
export function clearBannerStates(system) {
  const bannerConfigs = getBannerConfigs(system)
  bannerConfigs.forEach(config => {
    localStorage.removeItem(config.storageKey)
  })
}
